import React, {useState, useEffect} from 'react'
import axios from 'axios';
import DatePicker from 'react-datepicker';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";


 
const DailyTrack = ({
    id,
  handleToast,
  closeLoading,
  handleLoading,
}) => {

    const dateOne = new Date();
  dateOne.setDate(dateOne.getDate() - 1);

    const [reports, setReports] = useState([]);
    const [dueReports, setDueReports] = useState([]);
    // const [filters, setFilters] = useState({
    //   roomId: "",
    // });
    const [startDate, setStartDate] = useState(dateOne);
    const [endDate, setEndDate] = useState(new Date());
    const [filteredReports, setFilteredReports] = useState([]);
  const [totalCheckedInAmount, setTotalCheckedInAmount] = useState("0.00");
  const [totalCheckedOutAmount, setTotalCheckedOutAmount] = useState("0.00");
  const [totalDueAmount, setTotalDueAmount] = useState("0.00");
    const [rooms, setRooms] = useState([]);
  
    
      useEffect(() => {
    // localStorage.removeItem('rooms');
    const storedRooms = localStorage.getItem("rooms");
    if (storedRooms) {
          console.log(storedRooms);
      setRooms(JSON.parse(storedRooms));
    } else {
      axios
        .get(`https://api.dectwinhotel.com/api/${id}_rooms/rooms`)
        .then((response) => {
          localStorage.setItem("rooms", JSON.stringify(response.data));
          console.log(response.data);
          setRooms(response.data);
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            window.location.reload();
          }
          console.error("Error fetching products:", error);
        });
    }
  }, [id]);



    const fetchDueReports = async () => {
    handleLoading();

    try {
      const response = await axios.post(
        `https://api.dectwinhotel.com/api/${id}_due_payments/due-reports`,
        {
          startDate,
          endDate,
        }
      );
      closeLoading();
      handleToast({
        toastMsg: "Reports Fetched Successfully!!!",
        toastColor: "#4CAF50",
      });

       const sortedData = response.data.sort((a, b) => {
      return Number(a.inv_no) - Number(b.inv_no);
    });

      setDueReports(sortedData);
      console.log(response.data);
      // setFilteredReports(sortedData);
    } catch (err) {
      if (err.code === "ECONNABORTED") {
        fetchDueReports();
      }
      handleToast({
        toastMsg: "Something went wrong! Please try again",
        toastColor: "#FF0000",
      });
      closeLoading();
    }
  };


  const fetchReports = async () => {
    handleLoading();

    try {
      const response = await axios.post(
        `https://api.dectwinhotel.com/api/${id}_bookings/reports`,
        {
          startDate,
          endDate,
        }
      );
      closeLoading();
      handleToast({
        toastMsg: "Reports Fetched Successfully!!!",
        toastColor: "#4CAF50",
      });

       const sortedData = response.data.sort((a, b) => {
      return Number(a.inv_no) - Number(b.inv_no);
    });

      setReports(sortedData);
      console.log(response.data);
      setFilteredReports(sortedData);
    } catch (err) {
      if (err.code === "ECONNABORTED") {
        fetchReports();
      }
      handleToast({
        toastMsg: "Something went wrong! Please try again",
        toastColor: "#FF0000",
      });
      closeLoading();
    }
  };


useEffect(() => {
  if (!Array.isArray(filteredReports) || filteredReports.length === 0) {
    setTotalCheckedInAmount("0.00");
    setTotalCheckedOutAmount("0.00");
    return;
  }

  const checkedInAmount = filteredReports
    .filter((booking) => !booking.checkout_status)
    .reduce((sum, booking) => {
      return sum + parseFloat(booking.advance_amount || 0);
    }, 0)
    .toFixed(2);

  const checkedOutAmount = filteredReports
    .filter((booking) => booking.checkout_status)
    .reduce((sum, booking) => {
      return (
        sum +
        (parseFloat(booking.total_amount || 0) +
          parseFloat(booking.tax_amount || 0) +
        parseFloat(booking.extra_charges || 0)) -
        parseFloat(booking.last_amount)
        // parseFloat(booking.tax_amount || 0)
      );
    }, 0)
    .toFixed(2);

      const dueAmount = dueReports
    .reduce(
      (sum, booking) =>
        sum +
          parseFloat(booking.amount || 0),
      0
    )
    .toFixed(2);

  setTotalDueAmount(dueAmount);
  setTotalCheckedInAmount(checkedInAmount);
  setTotalCheckedOutAmount(checkedOutAmount);
}, [filteredReports]);

  
const totalSales = (
  parseFloat(totalCheckedInAmount) +
  parseFloat(totalCheckedOutAmount) +
    parseFloat(totalDueAmount)

).toFixed(2);

const dailySalesPieData = [
  {
    name: "Check In",
    value: parseFloat(totalCheckedInAmount),
  },
  {
    name: "Check Out",
    value: parseFloat(totalCheckedOutAmount),
  },
    {
    name: "Dues Collected",
    value: parseFloat(totalDueAmount),
  },

];



const occupiedRooms = rooms.filter(
  (b) => b.room_status == 'booked'
).length;

const vacantRooms = Math.max(rooms.length - occupiedRooms, 0);

const occupancyPercentage = rooms.length
  ? ((occupiedRooms / rooms.length) * 100).toFixed(2)
  : "0.00";

const occupancyPieData = [
  { name: "Occupied Rooms", value: occupiedRooms },
  { name: "Vacant Rooms", value: vacantRooms },
];


  return (
    <>
    <section
      style={{
        backgroundColor: "#282c34",
        padding: "4rem 1rem",
      }}
    >
        <div className="reports-page">

          <h2 className="text-start">Daily Tracking- Occupancy & Sales</h2>
          <div className="row my-3">
            <div className="col-lg-4 col-12 my-2">
              <label>Date Range:</label>
              <div className="date-picker">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
  dateFormat="dd/MM/yyyy"                />
                <span>to</span>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
  dateFormat="dd/MM/yyyy"                />
              </div>
            </div>

            {/* <div className="col-lg-2 col-12 my-2">
              <label>Room Number:</label>
              <input
                type="text"
                name="roomId"
                value={filters.roomId}
                // onChange={handleFilterChange}
                placeholder="Enter room number"
              />
            </div> */}


            <div className="col-lg-2 col-12 my-2 pt-4">
              <button className="fetch-btn mt-2" onClick={() => (fetchReports(), fetchDueReports())}>
                Fetch Reports
              </button>
            </div>
          </div>

{reports.length > 0 && 
<div className="row mt-5">
  <div className="col-lg-6 col-12">
    <h5 className="text-center">
      Sales Distribution
    </h5>
        <p className='text-center'>
      💰 Total Collection: ₹{totalSales}
    </p>


    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={dailySalesPieData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={110}
          label={({ name, value }) =>
            `${name}: ₹${value.toFixed(2)}`
          }
        >
          <Cell fill="#4CAF50" />
          <Cell fill="#2196F3" />
          <Cell fill="red" />
        </Pie>

        <Tooltip formatter={(value) => `₹${value}`} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>

    
  </div>

  <div className="col-lg-6 col-12">
    <h5 className="text-center">
      Daily Occupancy Data
          </h5>
        <p className='text-center'>
      🏢 Total Rooms: {rooms.length} | Occ Rate: {occupancyPercentage}%
    </p>

  <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={occupancyPieData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={110}
          label={({ name, value }) => `${name}: ${value}`}
        >
          <Cell fill="green" />
          <Cell fill="#FF9800" />
        </Pie>

        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
    
  </div>
</div>
}

          </div>


          </section>
    </>
  )
}

export default DailyTrack